import React from 'react';
import { render } from 'react-dom';

import { errorCodes, getErrorMessageKey } from '../../util/errorCodes';
import jsonGet from '../../util/jsonGet';

import BookingDetails from '../react/BookingDetails';
import { formatDate } from '../react/BookingFieldset/helpers';
import ErrorMessage from '../react/Core/ErrorMessage';
import Loading from '../react/Core/Loading';
import ProgressBar from '../react/ProgressBar';

export default class BookingDetailsRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { apiUrl, model, pcaPredictKey, currentProgressBarStep, loadApi, title } =
      this.context.dataset;
    if (!apiUrl || !model || !pcaPredictKey || !currentProgressBarStep || !loadApi)
      throw Error('Missing a required dataset');

    let labels;
    try {
      labels = JSON.parse(model);
    } catch (e) {
      labels = undefined;
      console.error('Error parsing labels json: ', model);
    }

    const urlSearchParams = new URLSearchParams(window.location.search);
    const orderId = urlSearchParams.get('OrderId') || urlSearchParams.get('orderId');
    const loadApiUrl = `${loadApi}/${orderId}`;

    jsonGet(loadApiUrl, null, (response) => {
      if (response.errorCode) {
        if (response.errorCode === errorCodes.TourBookingTourHasReachedPaxCapLimit) {
          window.location.href = response.redirectUri;
        }
        const errorMessageKey = getErrorMessageKey(response.errorCode);
        return render(
          <ErrorMessage text={labels[errorMessageKey] || response.message} />,
          this.context
        );
      }

      return render(
        BookingDetailsRender.renderMain(
          response,
          labels,
          apiUrl,
          title,
          currentProgressBarStep,
          pcaPredictKey,
          orderId
        ),
        this.context
      );
    });

    return render(
      BookingDetailsRender.renderMain(
        undefined,
        labels,
        apiUrl,
        title,
        currentProgressBarStep,
        pcaPredictKey,
        orderId
      ),
      this.context
    );
  }

  static renderMain(
    passengerDetailsLoadData,
    labels,
    apiUrl,
    title,
    selectedStep,
    pcaPredictKey,
    orderId
  ) {
    const data = passengerDetailsLoadData;

    if (data) {
      // Format Lead Party Member Date of Birth
      if (data.leadBooker.dateOfBirth) {
        data.leadBooker.dateOfBirth = formatDate(data.leadBooker.dateOfBirth);
      }

      // Format Party Members Date of Birth
      data.partyMembers.forEach((partyMember, index) => {
        if (partyMember.dateOfBirth) {
          data.partyMembers[index].dateOfBirth = formatDate(partyMember.dateOfBirth);
        }
      });
    }

    return (
      <>
        <ProgressBar steps={data?.progressBarSteps} selectedStep={selectedStep} orderId={orderId} />
        <div className="PageTitle">
          <h1 className="PageTitle_title">{title}</h1>
        </div>
        {data ? (
          <BookingDetails
            data={data}
            labels={labels}
            apiURL={apiUrl}
            pcaPredictKey={pcaPredictKey}
            orderId={orderId}
          />
        ) : (
          <Loading />
        )}
      </>
    );
  }
}
